import { Link } from 'react-router-dom';
import './Solutions.css';
import solSolar from '../../assets/sol_solar_trimmed.png';
import solBattery from '../../assets/battery_storage_house2.png';
import solUpgrade from '../../assets/sol_upgrade2.png';
import solCustom from '../../assets/sol_custom_energy_trimmed.png';
import wattleBlue from '../../assets/figma_wattle_blue.svg';

const solutions = [
  { badge: 'Solution 1', title: 'Solar Power System', desc: 'Generate your own electricity with a complete solar setup', image: solSolar },
  { badge: 'Solution 2', title: 'Battery Storage', desc: 'Store energy and use it when you need it most — even at night', image: solBattery },
  { badge: 'Solution 3', title: 'System Upgrades', desc: 'Upgrade your existing solar system with battery and smart control', image: solUpgrade },
  { badge: 'Solution 4', title: 'Custom Energy Solutions', desc: 'Tailored systems designed for your home and energy needs', image: solCustom },
];

export default function Solutions() {
  return (
    <section className="solutions-section">
      <div className="solutions-inner">
        <div className="solutions-cards-grid">
          {solutions.map((sol, i) => (
            <div key={i} className="solution-card">
              <div className="solution-card-top">
                <span className="solution-badge">{sol.badge}</span>
                <h3 className="solution-title">{sol.title}</h3>
                <p className="solution-desc">{sol.desc}</p>
              </div>
              <div className="solution-img-wrap">
                <img src={sol.image} alt={sol.title} className="solution-img" />
              </div>
            </div>
          ))}
        </div>

        <div className="solutions-info-panel">
          <div className="solutions-panel-content">
            <h2 className="solutions-panel-title">Smart energy solutions for your home</h2>
            <p className="solutions-panel-desc">
              Whether you're starting from scratch or upgrading your system, we've got you covered.
            </p>
            <Link to="/contact" className="solutions-panel-btn">
              Find the right system for your home
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                <path d="M5 12h14M12 5l7 7-7 7" stroke="#050b14" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </Link>
          </div>
          <div className="solutions-wattle-decoration">
            <img src={wattleBlue} alt="" className="solutions-wattle-img" />
          </div>
        </div>
      </div>
    </section>
  );
}
